
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalAcademyData from '@/components/templates/manage/ModalAcademyData.vue'
import AcademyCodeUtils from '@/utils/AcademyCodeUtils'
import { AcademiesApi } from '@/api/methods/manage/AcademiesApi'
import StringUtils from '@/utils/StringUtils'

/**
 * 塾登録モーダル
 */
@Component({
  components: {
    ModalAcademyData,
  },
})
export default class ModalRegistAcademy extends Vue {
  /** 塾編集モーダルのフォーマット */
  @Ref()
  modalAcademyData!: ModalAcademyData

  /** 塾更新後の処理 */
  @Prop()
  private afterUpdateAcademy!: () => Promise<void>

  /**
   * 送信ボタンのdisabled制御
   *
   * @param academyName 塾名
   * @param academyCode 塾コード
   * @returns 未入力があった場合はtrue
   */
  private submitDisabled(academyName: string, academyCode: string): boolean {
    // 塾名が未入力の場合true
    if (StringUtils.isBlank(academyName)) {
      return true
    }

    // 塾コードが未入力の場合true
    if (StringUtils.isBlank(academyCode)) {
      return true
    }

    return false
  }

  /**
   * 確認ボタン押下時の処理
   */
  private async submit(): Promise<void> {
    this.$loading.start()

    let errorMessage = null

    // コード指定が適切かのチェック
    errorMessage = AcademyCodeUtils.checkCodeEnabled(this.modalAcademyData.academyCode)
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // 塾登録
    await AcademiesApi.createAcademy(this.modalAcademyData.academyName, this.modalAcademyData.academyCode)

    this.$loading.complete()

    // モーダルを閉じる
    this.hide()

    // 塾更新後の処理
    await this.afterUpdateAcademy()
  }

  /**
   * モーダルを開く
   */
  public async show(): Promise<void> {
    this.$loading.start()

    // モーダルを開く
    this.modalAcademyData.show()

    this.$loading.complete()
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalAcademyData.hide()
  }
}
